import { HttpBackend, HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

export interface SimpleFonoArea {
	code: string;
	name: string;
}

export interface SimpleFonoCallRequest {
	name: string;
	phoneNumber: string;
	origin: string;
	areaCode?: string;
}

export interface SimpleFonoCallError {
	description?: string;
}

export interface SimpleFonoCallResponse {
	token?: string;
	fromPhoneNumber?: string | null;
	isError?: boolean;
	error?: SimpleFonoCallError;
}

export interface SimpleFonoRequestResult<T> {
	ok: boolean;
	status: number;
	data: T | null;
}

export interface SimpleFonoRateRequest {
	rating: number;
	comment?: string;
}

@Injectable({
	providedIn: "root",
})
export class SimpleFonoService {
	private readonly rawHttp: HttpClient;
	private readonly baseUrl = environment.simpleFono_server;

	constructor(httpBackend: HttpBackend) {
		// SimpleFono usa su propio token temporal. Evitamos interceptores globales.
		this.rawHttp = new HttpClient(httpBackend);
	}

	getAreas(): Observable<SimpleFonoArea[]> {
		return this.rawHttp.get<SimpleFonoArea[]>(this.baseUrl + "/areas/simple");
	}

	requestCall(payload: SimpleFonoCallRequest): Observable<SimpleFonoCallResponse> {
		return this.rawHttp.post<SimpleFonoCallResponse>(this.baseUrl + "/call-me", payload);
	}

	async requestCallLikeRazor(payload: SimpleFonoCallRequest): Promise<SimpleFonoRequestResult<SimpleFonoCallResponse>> {
		const response = await fetch(this.baseUrl + "/call-me", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(payload),
		});

		let data: SimpleFonoCallResponse | null = null;

		try {
			data = await response.json();
		} catch (error) {
			data = null;
		}

		return {
			ok: response.ok,
			status: response.status,
			data,
		};
	}

	rateCall(token: string, payload: SimpleFonoRateRequest): Observable<void> {
		const headers = new HttpHeaders({
			Authorization: "Bearer " + token,
			"Content-Type": "application/json",
		});

		return this.rawHttp.post<void>(this.baseUrl + "/call-me/rate-call", payload, { headers });
	}

	getHubUrl(): string {
		return this.baseUrl + "/hubs/call-me";
	}
}
